// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AwQDWgU8FY7tjh {
  height: 100%;
}
.mf8mA_sLKHMZUy {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 8px;
  gap: 4px;
}
.ibyswhRdKeHdu0 {
  display: flex;
  flex: 1;
  gap: 4px;
  flex-wrap: wrap;
  align-content: flex-start;
}
.rWFas5BpmC9Eyy {
  height: min-content;
  margin: 0;
}
.nGFMrsdxOUJQOS {
  display: flex;
  flex-direction: column;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newBoardTile": `AwQDWgU8FY7tjh`,
	"boardTagsContainer": `mf8mA_sLKHMZUy`,
	"boardTags": `ibyswhRdKeHdu0`,
	"tag": `rWFas5BpmC9Eyy`,
	"addTag": `nGFMrsdxOUJQOS`
};
export default ___CSS_LOADER_EXPORT___;
